import { useState } from 'react';

export default function Features() {
  const [showJoinModal, setShowJoinModal] = useState(false);

  const features = [
    {
      icon: 'ri-sword-line',
      title: 'PvP Arena',
      description: 'Özel tasarlanmış arenalarda diğer oyuncularla savaş ve en iyisi ol. Sıralamada yüksel ve ödüller kazan.',
      comingSoon: true
    },
    {
      icon: 'ri-building-line',
      title: 'Survival',
      description: 'Geniş dünyamızda hayatta kal, kaynak topla ve kendi üssünü inşa et. Ekonomi sistemi ile ticaret yap.',
      comingSoon: true
    },
    {
      icon: 'ri-treasure-map-line',
      title: 'Skyblock',
      description: 'Küçük bir adadan başla ve gökyüzünde kendi imparatorluğunu kur. Eşsiz adalar ve görevler seni bekliyor.',
      comingSoon: false
    },
    {
      icon: 'ri-game-line',
      title: 'Mini Oyunlar',
      description: 'BedWars, SkyWars, BuildBattle ve daha fazlası! Her gün yeni mini oyunlar ve etkinlikler.',
      comingSoon: true
    },
    {
      icon: 'ri-team-line',
      title: 'Klan Sistemi',
      description: 'Arkadaşlarınla klan kur, topraklarını genişlet ve diğer klanlarla savaş. Klan savaşlarında zafer kazan.',
      comingSoon: true
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'Özel Market',
      description: 'Oyun içi para kazan ve marketten özel itemler, kozmetikler ve yetenekler satın al.',
      comingSoon: true
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'VIP Paketler',
      description: 'Premium üyeliklerle özel komutlar, kozmetikler ve avantajlar kazan. Her seviyeye uygun paketler.',
      comingSoon: true
    },
    {
      icon: 'ri-trophy-line',
      title: 'Etkinlikler',
      description: 'Haftalık turnuvalar, özel etkinlikler ve yarışmalar. Kazananlara özel ödüller ve unvanlar.',
      comingSoon: true
    },
    {
      icon: 'ri-magic-line',
      title: 'Özel Pluginler',
      description: 'Sadece bizde olan özel yapım pluginler ile benzersiz bir Minecraft deneyimi yaşa.',
      comingSoon: true
    }
  ];

  return (
    <>
      <section id="features" className="py-20 px-4 bg-[#0a0e1a]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Sunucu Özellikleri
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Sunucumuzda seni bekleyen eşsiz özellikler ve oyun modları
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="group bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-xl p-6 border border-[#3b82f6]/10 hover:border-[#3b82f6]/40 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-xl hover:shadow-[#3b82f6]/20 relative"
              >
                {feature.comingSoon && (
                  <div className="absolute top-4 right-4">
                    <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full" style={{ fontFamily: 'Minecraft, monospace' }}>
                      YAKINDA
                    </span>
                  </div>
                )}
                <div className="w-16 h-16 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#3b82f6]/30 transition-all duration-300">
                  <i className={`${feature.icon} text-3xl text-[#3b82f6]`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-r from-[#3b82f6]/10 to-[#2563eb]/10 rounded-2xl p-8 border border-[#3b82f6]/20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                  Daha Fazlasını Keşfet!
                </h3>
                <p className="text-gray-400">
                  Sunucumuza katıl ve tüm özellikleri deneyimle. Seni harika bir macera bekliyor!
                </p>
              </div>
              <button 
                onClick={() => setShowJoinModal(true)}
                className="bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white px-8 py-4 rounded-lg text-lg font-bold hover:from-[#2563eb] hover:to-[#1d4ed8] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Sunucuya Katıl
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Join Server Modal */}
      {showJoinModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl max-w-2xl w-full border border-[#3b82f6]/30 shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-[#3b82f6]/20 sticky top-0 bg-gradient-to-br from-[#1a1f35] to-[#0f1420] z-10">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold text-white">
                  <i className="ri-gamepad-line mr-2"></i>
                  Sunucuya Nasıl Katılırım?
                </h3>
                <button
                  onClick={() => setShowJoinModal(false)}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Step 1 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">1</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Minecraft'ı Aç</h4>
                    <p className="text-gray-400 text-sm mb-3">
                      Minecraft Java Edition'ı başlatın ve ana menüye gelin.
                    </p>
                    <div className="bg-[#1a1f35] rounded-lg p-3 border border-[#3b82f6]/10">
                      <i className="ri-information-line text-[#3b82f6] mr-2"></i>
                      <span className="text-gray-300 text-sm">Minecraft Java Edition 1.8 veya üzeri gereklidir</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">2</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Çok Oyunculu'ya Tıkla</h4>
                    <p className="text-gray-400 text-sm">
                      Ana menüden "Multiplayer" veya "Çok Oyunculu" butonuna tıklayın.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">3</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Sunucu Ekle</h4>
                    <p className="text-gray-400 text-sm mb-4">
                      "Add Server" veya "Sunucu Ekle" butonuna tıklayın ve aşağıdaki bilgileri girin:
                    </p>
                    
                    {/* Skyblock Server */}
                    <div className="mb-4">
                      <div className="flex items-center gap-2 mb-2">
                        <i className="ri-treasure-map-line text-[#3b82f6]"></i>
                        <span className="text-white font-semibold">Skyblock Sunucusu</span>
                      </div>
                      <div className="bg-[#1a1f35] rounded-lg p-4 border border-[#3b82f6]/10">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-gray-400 text-sm">Sunucu Adresi:</span>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText('emerald.magmanode.com:30515');
                            }}
                            className="text-[#3b82f6] hover:text-[#2563eb] transition-colors cursor-pointer text-sm"
                          >
                            <i className="ri-file-copy-line mr-1"></i>
                            Kopyala
                          </button>
                        </div>
                        <code className="text-[#3b82f6] font-mono text-sm block">emerald.magmanode.com:30515</code>
                      </div>
                    </div>

                    {/* BoxPvP Server */}
                    <div>
                      <div className="flex items-center gap-2 mb-2">
                        <i className="ri-sword-line text-[#3b82f6]"></i>
                        <span className="text-white font-semibold">BoxPvP Sunucusu</span>
                      </div>
                      <div className="bg-[#1a1f35] rounded-lg p-4 border border-[#3b82f6]/10">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-gray-400 text-sm">Sunucu Adresi:</span>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText('Windo5DJBX.aternos.me');
                            }}
                            className="text-[#3b82f6] hover:text-[#2563eb] transition-colors cursor-pointer text-sm"
                          >
                            <i className="ri-file-copy-line mr-1"></i>
                            Kopyala
                          </button>
                        </div>
                        <code className="text-[#3b82f6] font-mono text-sm block">Windo5DJBX.aternos.me</code>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div className="bg-[#0a0e1a] rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-[#3b82f6]">4</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-3">Sunucuya Bağlan</h4>
                    <p className="text-gray-400 text-sm mb-3">
                      Sunucu adresini girdikten sonra "Done" veya "Bitti" butonuna tıklayın. 
                      Ardından sunucuya çift tıklayarak veya "Join Server" butonuna basarak bağlanın.
                    </p>
                    <div className="bg-gradient-to-r from-[#3b82f6]/10 to-[#2563eb]/10 rounded-lg p-4 border border-[#3b82f6]/20">
                      <div className="flex items-start gap-3">
                        <i className="ri-lightbulb-line text-[#3b82f6] text-xl flex-shrink-0 mt-0.5"></i>
                        <div>
                          <p className="text-white font-semibold text-sm mb-1">İpucu</p>
                          <p className="text-gray-300 text-sm">
                            Sunucuya ilk kez bağlanıyorsanız, kayıt olmanız gerekebilir. 
                            Oyun içi komutları takip edin!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Help Section */}
              <div className="bg-gradient-to-r from-[#3b82f6]/10 to-[#2563eb]/10 rounded-xl p-6 border border-[#3b82f6]/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-2xl text-[#3b82f6]"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-2">Yardıma mı İhtiyacın Var?</h4>
                    <p className="text-gray-400 text-sm mb-4">
                      Sunucuya bağlanırken sorun yaşıyorsan Discord sunucumuzdan destek alabilirsin!
                    </p>
                    <a
                      href="https://discord.gg/7MzuPKd9SD"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 bg-[#5865F2] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#4752C4] transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-discord-fill"></i>
                      Discord'a Git
                    </a>
                  </div>
                </div>
              </div>

              {/* Close Button */}
              <button
                onClick={() => setShowJoinModal(false)}
                className="w-full bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white py-4 rounded-lg font-semibold hover:from-[#2563eb] hover:to-[#1d4ed8] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Anladım, Hadi Oynayalım!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
